import { concat, flatten } from 'lodash';
import { useSelector } from 'react-redux';

import { RosterYouthMember } from '@appTypes/esb/organizations/v2/units/_orgGuid/youths';
import { subUnitGroupingAllowed } from '@modules/advancement/constants';
import { useUnitRoster } from '@modules/advancement/duck/hooks';
import { extraType } from '@modules/events/constants';
import { useGetMultipleSubUnitsQuery } from '@modules/rtk/esb-api';
import {
  organizationGuidSel,
  unitTypeIdSel,
} from '@shared/duck/selectors/general.selectors';

export const useGetAllSubUnitsWithYouth = () => {
  const orgGuid = useSelector(organizationGuidSel);
  const unitTypeId = useSelector(unitTypeIdSel);
  const { data, isLoading: fetchLoading } = useGetMultipleSubUnitsQuery(
    {
      orgGuids: [orgGuid],
    },
    { skip: !subUnitGroupingAllowed.includes(unitTypeId) },
  );
  const { youths, isRosterLoading } = useUnitRoster();

  const isLoading = isRosterLoading || fetchLoading;

  const flattenSubUnits = flatten(data);
  const subForUnassigned = {
    subUnitNameFull: extraType.UNASSIGNED,
    subUnitName: extraType.UNASSIGNED,
    isDen: unitTypeId === 1 ? true : false,
    // required type
    unitId: 0,
    subUnitId: 0,
    denTypeId: null,
    denType: null,
    isApproved: false,
    isForumEnabled: false,
    showDlEvents: null,
    dateCreated: '',
  };
  const subUnits = flattenSubUnits;
  const youthInSubUnit: number[] = [];

  const subUnitsWithYouth = subUnits.map(sub => {
    const youthMembers = (youths as RosterYouthMember[]).filter(youth =>
      youth.positions.some(pos =>
        [pos.patrolId, pos.denId].includes(sub.subUnitId),
      ),
    );
    youthInSubUnit.push(...youthMembers.map(youth => youth.userId));
    return {
      ...sub,
      subRows: youthMembers,
    };
  });

  const unassignedWithYouth = {
    ...subForUnassigned,
    subRows: (youths as RosterYouthMember[]).filter(
      youth => !youthInSubUnit.includes(youth.userId),
    ),
  };

  return { data: concat(subUnitsWithYouth, unassignedWithYouth), isLoading };
};
